import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">社区特色</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60 hover:border-primary-200/60 transition-all duration-200 group cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-200">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}